export enum PunchlistItemState
{
    ToDo,
    Processing, 
    Complete, 
    Error
}

export interface PunchlistItem<TOrder>
{
    titles: PunchlistStateText,
    order: TOrder,
    subTitles?: PunchlistStateText,
    state?: PunchlistItemState,
    title?: string,     // Pulled from titles based on state
    subTitle?: string,  // Pulled from subTitles based on state
    hidden?: boolean   // If not set, display the item
}

export interface PunchlistStateText 
{
    todo?: string, 
    processing?: string, 
    complete?: string, 
    error?: string
}

// // Set the title property to the 'todo' state text
// export function resetTitles<TOrder extends string | number>(items: PunchlistItem<TOrder>[], titles: Record<TOrder, PunchlistStateText>): PunchlistItem<TOrder>[]
// {
//     for(const item of items)
//     {
//         item.title = titles[item.order].todo ?? "";
//     }
//     return items;
// }

export class PunchListState<TOrder extends string | number>
{
    private items: PunchlistItem<TOrder>[] = [];

    constructor(items: PunchlistItem<TOrder>[])
    {
        this.items = items;
        this.reset();
    }

    // Reset the puchlist items to the 'Todo' state
    reset(itemsToExcludeFromReset?: TOrder[])
    {
        for(const item of this.items)
        {
            // Bypass this item?
            if (itemsToExcludeFromReset?.includes(item.order))
                continue;

            this.updateState(item.order, PunchlistItemState.ToDo);
        }
    }

    get punchListItems(): PunchlistItem<TOrder>[]
    {
        return this.items;
    }

    updateState(order: TOrder, state: PunchlistItemState)
    {
        if (undefined === order)
        {
            alert(`Punchlist order value cannot be undefined`);
            return;
        }
        if (undefined === state)
        {
            alert(`Punchlist state value cannot be undefined`);
            return;
        }        

        const item = this.items.find(item => item.order == order);
        if (!item)
        {
            alert(`Unable to find punchlist item for ${order}`);
            return;
        }

        switch(state)
        {
            case PunchlistItemState.ToDo:
                item.title = item.titles.todo;
                item.subTitle = item.subTitles?.todo;
            break;
            case PunchlistItemState.Processing:
                item.title = item.titles.processing;
                item.subTitle = item.subTitles?.processing;
            break;
            case PunchlistItemState.Complete:
                item.title = item.titles.complete;
                item.subTitle = item.subTitles?.complete;
            break;
            case PunchlistItemState.Error:
                item.title = item.titles.error;
                item.subTitle = item.subTitles?.error;
            break;
        }        

        item.state = state;

        if (this.onStateChange)
        {
            switch(state)
            {
                case PunchlistItemState.Error:
                    this.onStateChange(PunchlistStateType.Error);
                    break;
                case PunchlistItemState.Processing:
                    this.onStateChange(PunchlistStateType.Processing);
                    break;
                case PunchlistItemState.Complete:
                    this.onStateChange(PunchlistStateType.Complete);
                    break;
                default:
                    this.onStateChange(undefined);
                    break;                    
            }
        }
    }

    onStateChange?: (puchlistState?: PunchlistStateType) => void
}

// The status of the punchlist
export enum PunchlistStateType
{
    Processing,
    Complete,
    Error
}